import React, { useRef, useState } from "react"
import { IInnRegistryDto } from "../../../types/inn/IInnRegistryDto"
import { ModalConfirm } from "../../common/element/ModalConfirm"
import { ModalPopUp } from "../../common/element/ModalPopUp"
import { IModalMessage } from "../../../types/error/IModalMessage"
import { BanksTable } from "./Banks"

import style from "./style.module.scss"
import Button from "@/ui/components/Button"

export const CurrencyPayerPopUpListItem: React.FC<{
  inn: IInnRegistryDto
  remove: (id: number) => void
  lockUnlock: (inn: IInnRegistryDto) => void
  approve: (inn: IInnRegistryDto) => void
  refetch: () => void
}> = ({ inn, remove, lockUnlock, approve, refetch }) => {
  const [modalConfirm, setModalConfirm] = useState<IModalMessage>()
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const [showBanks, setShowBanks] = useState(false)
  const userMenu = useRef<HTMLDivElement>(null)

  const getHumanStatus = (status: string | undefined) => {
    switch (status) {
      case "BLOCKED":
        return "Заблокирована"
      case "APPROVED":
        return "Одобрена"
      case "PENDING":
        return "Новая"
      default:
        return "Ошибка статуса"
    }
  }

  const toggleMenu = () => {
    if (userMenu.current) {
      if (userMenu.current.style.left === "0%") {
        userMenu.current.style.display = "none"
        userMenu.current.style.left = "100%"
      } else {
        userMenu.current.style.display = "flex"
        userMenu.current.style.left = "0%"
      }
      //userMenu.current.style.left = userMenu.current.style.left === "0%" ? "100%" : "0%";
    }
  }

  const lockUnlockHandler = () => {
    toggleMenu()
    lockUnlock(inn)
  }

  const approveHandler = () => {
    toggleMenu()
    approve(inn)
  }

  const confirmRemove = (val: any) => {
    if (val) {
      toggleMenu()
      remove(val)
    }
  }

  return (
    <div>
      <ModalConfirm message={modalConfirm} setMessage={setModalConfirm} />
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
      <li className="currency_inn_header_list">
        <p>{inn.name}</p>
        <p>{inn.address || "-"}</p>
        <p>{getHumanStatus(inn.status)}</p>
        <button className="openmenu" onClick={toggleMenu} />
        <Button variant="black" onClick={() => setShowBanks(!showBanks)} className={style.banksButton}>
          Банки
        </Button>
        <div id="menu-itemINN" ref={userMenu}>
          <p className="menu-cpmpany-button-blank" />
          {inn.status === "PENDING" ? (
            <p className="menu-cpmpany-button" onClick={approveHandler}>
              Одобрить
            </p>
          ) : (
            <p className="menu-cpmpany-button-blank" />
          )}
          <p
            className="menu-cpmpany-button"
            onClick={() =>
              setModalConfirm({
                title: "Удалить ИНН?",
                text: `Вы действительно желаете удалить валютного плательщика (${inn.name})?`,
                callbackValue: inn.id,
                _callback: confirmRemove
              })
            }
          >
            Удалить
          </p>
          <p className="menu-cpmpany-button" onClick={lockUnlockHandler}>
            {inn.status === "BLOCKED" ? "Разблокировать" : "Заблокировать"}
          </p>
          <button id="closemenuINN" onClick={toggleMenu} />
        </div>
      </li>

      {showBanks && (
        <div className={style.banks}>
          <BanksTable title={inn.name || ""} banks={inn.banksRef || []} payerId={String(inn.id)} refetch={refetch} />
        </div>
      )}
    </div>
  )
}
